/**
 *
 * @type {typeof import("./zh_TW")}
 *
 */
module.exports = {
  '56676244.ot.check.limit': {
    'code450': '超出可加班限制次数',
  },
  '56676244.leave.limit.apply': {
    'code451': '需于请假 <%= A %>工作天前 提出申请',
    'code452': '需于请假 <%= A %>历日前 提出申请',
  },
  '56676244.leave.limit.approve': {
    'code451': '需于请假 <%= A %>工作天前 签核完成',
    'code452': '需于请假 <%= A %>历日前 签核完成',
  },
  '56676244.leave.error': {
    'code459': '非预期性错误',
  },
};
